import { AB_TESTING_FLAGS } from "@/constants/analytics.constants";
import { pushEasyApplyFilter } from "@/utils/avoGtm.utils";
import { isSSR } from "@/utils/compute.utils";
import { useAB } from "@tajawal/web-common/lib";
import { useState } from "react";
import { useComputeSplitQueryAttrs } from "./useComputeSplitQueryAttrs";
import _omit from "lodash/omit";

export function useEasyFiltersAB({ applyEasyApplyFilters, syncedFilters }) {
  const [isEasyFiltersApplied, setIsEasyFiltersApplied] = useState(false);
  const attributes = useComputeSplitQueryAttrs();
  const splitAttributes = _omit(attributes, [
    "origin_iata",
    "destination_iata",
  ]);
  const { active } = useAB(
    AB_TESTING_FLAGS.EASY_APPLY_FILTERS,
    splitAttributes,
  );

  const isEasyApplyFiltersSessionEnded = !isSSR()
    ? sessionStorage.getItem(AB_TESTING_FLAGS.EASY_APPLY_FILTERS)
    : false;

  function handleSyncFilters(e) {
    e?.stopPropagation();

    applyEasyApplyFilters(true);
    pushEasyApplyFilter("apply", syncedFilters);
    setIsEasyFiltersApplied(true);
    !isSSR() && sessionStorage.removeItem(AB_TESTING_FLAGS.EASY_APPLY_FILTERS);
  }

  function handleDismissEasyFilters(e) {
    e?.stopPropagation();

    applyEasyApplyFilters();
    pushEasyApplyFilter("dismissed", syncedFilters);
    !isSSR() &&
      sessionStorage.setItem(AB_TESTING_FLAGS.EASY_APPLY_FILTERS, "true");
  }

  return {
    isEasyApplyEnabled:
      active && !isEasyApplyFiltersSessionEnded && !isEasyFiltersApplied,
    handleSyncFilters,
    handleDismissEasyFilters,
    setIsEasyFiltersApplied,
  };
}
